module.exports = __webpack_public_path__ + "img/strength-5.053133c9.png";